query TravelAuthorizationAvailableTags($id: UUID!) {
  travelAuthorizationAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
